import { PROTOCOLS } from "../types";

export const formatProtocol = (protocol: PROTOCOLS): string =>
  protocol === PROTOCOLS.ANY ? protocol : protocol.toUpperCase();
